import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId1: SiteIdOverrideConfig = {
  car: {
    date: {
      maxDaysRange: 329,
    },
  },
};
